"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /**
                                                                                                                                                                                                                                                                                                                                                                                               * HiAlive
                                                                                                                                                                                                                                                                                                                                                                                               * HiAlive API
                                                                                                                                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                                                                                                                                               * The version of the OpenAPI document: 1.0.0
                                                                                                                                                                                                                                                                                                                                                                                               * Contact: lightimehpq@gmail.com
                                                                                                                                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                                                                                                                                               * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
                                                                                                                                                                                                                                                                                                                                                                                               * https://openapi-generator.tech
                                                                                                                                                                                                                                                                                                                                                                                               * Do not edit the class manually.
                                                                                                                                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                                                                                                                                               */
/**
* Stats service.
* @module api/StatsApi
* @version 1.0.0
*/
var StatsApi = exports["default"] = /*#__PURE__*/function () {
  /**
  * Constructs a new StatsApi. 
  * @alias module:api/StatsApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function StatsApi(apiClient) {
    _classCallCheck(this, StatsApi);
    this.apiClient = apiClient || _ApiClient["default"].instance;
  }

  /**
   * Callback function to receive the result of the getStatsArch operation.
   * @callback module:api/StatsApi~getStatsArchCallback
   * @param {String} error Error message, if any.
   * @param {Number} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * 获取指定架构所有报活过的节点总数
   * 获取指定架构所有报活过的节点总数
   * @param {String} arch 要统计的系统, e.g \"Amd64/I386/Arm64/Arm/Mips64/Mips/RiscV64/PPC64le/S390x\",
   * @param {module:api/StatsApi~getStatsArchCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link Number}
   */
  _createClass(StatsApi, [{
    key: "getStatsArch",
    value: function getStatsArch(arch, callback) {
      var postBody = null;
      // verify the required parameter 'arch' is set
      if (arch === undefined || arch === null) {
        throw new Error("Missing the required parameter 'arch' when calling getStatsArch");
      }
      var pathParams = {};
      var queryParams = {
        'arch': arch
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Number';
      return this.apiClient.callApi('/stats/arch', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getStatsOS operation.
     * @callback module:api/StatsApi~getStatsOSCallback
     * @param {String} error Error message, if any.
     * @param {Number} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 获取指定系统所有报活过的节点总数
     * 获取指定系统所有报活过的节点总数
     * @param {String} os 要统计的系统, e.g \"Windows\",
     * @param {module:api/StatsApi~getStatsOSCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Number}
     */
  }, {
    key: "getStatsOS",
    value: function getStatsOS(os, callback) {
      var postBody = null;
      // verify the required parameter 'os' is set
      if (os === undefined || os === null) {
        throw new Error("Missing the required parameter 'os' when calling getStatsOS");
      }
      var pathParams = {};
      var queryParams = {
        'os': os
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Number';
      return this.apiClient.callApi('/stats/os', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getStatsRelType operation.
     * @callback module:api/StatsApi~getStatsRelTypeCallback
     * @param {String} error Error message, if any.
     * @param {Number} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 获取指定发布形式所有报活过的节点总数
     * 获取指定发布形式所有报活过的节点总数
     * @param {String} relType 要统计的 App 发布形式, e.g \"App/Service\",
     * @param {module:api/StatsApi~getStatsRelTypeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Number}
     */
  }, {
    key: "getStatsRelType",
    value: function getStatsRelType(relType, callback) {
      var postBody = null;
      // verify the required parameter 'relType' is set
      if (relType === undefined || relType === null) {
        throw new Error("Missing the required parameter 'relType' when calling getStatsRelType");
      }
      var pathParams = {};
      var queryParams = {
        'RelType': relType
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Number';
      return this.apiClient.callApi('/stats/rel-type', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getStatsRunIn operation.
     * @callback module:api/StatsApi~getStatsRunInCallback
     * @param {String} error Error message, if any.
     * @param {Number} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 获取指定运行环境所有报活过的节点总数
     * 获取指定运行环境所有报活过的节点总数
     * @param {String} runIn 要统计的系统, e.g \"BareMetal/Docker/Electron/Systemd/Upstart\",
     * @param {module:api/StatsApi~getStatsRunInCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Number}
     */
  }, {
    key: "getStatsRunIn",
    value: function getStatsRunIn(runIn, callback) {
      var postBody = null;
      // verify the required parameter 'runIn' is set
      if (runIn === undefined || runIn === null) {
        throw new Error("Missing the required parameter 'runIn' when calling getStatsRunIn");
      }
      var pathParams = {};
      var queryParams = {
        'runIn': runIn
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Number';
      return this.apiClient.callApi('/stats/run-in', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getStatsTodayArch operation.
     * @callback module:api/StatsApi~getStatsTodayArchCallback
     * @param {String} error Error message, if any.
     * @param {Number} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 获取指定架构最近一天内报活过的节点总数
     * 获取指定架构最近一天内报活过的节点总数
     * @param {String} arch 要统计的架构, e.g \"Amd64/I386/Arm64/Arm/Mips64/Mips/RiscV64/PPC64le/S390x\",
     * @param {module:api/StatsApi~getStatsTodayArchCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Number}
     */
  }, {
    key: "getStatsTodayArch",
    value: function getStatsTodayArch(arch, callback) {
      var postBody = null;
      // verify the required parameter 'arch' is set
      if (arch === undefined || arch === null) {
        throw new Error("Missing the required parameter 'arch' when calling getStatsTodayArch");
      }
      var pathParams = {};
      var queryParams = {
        'arch': arch
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Number';
      return this.apiClient.callApi('/stats/today/arch', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getStatsTodayOS operation.
     * @callback module:api/StatsApi~getStatsTodayOSCallback
     * @param {String} error Error message, if any.
     * @param {Number} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 获取指定系统最近一天内报活过的节点总数
     * 获取指定版本最近一天内报活过的节点总数
     * @param {String} os 要统计的系统, e.g \"Windows/Darwin/Linux/Harmony/Android/Ipad/Iphone/OpenWrt\",
     * @param {module:api/StatsApi~getStatsTodayOSCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Number}
     */
  }, {
    key: "getStatsTodayOS",
    value: function getStatsTodayOS(os, callback) {
      var postBody = null;
      // verify the required parameter 'os' is set
      if (os === undefined || os === null) {
        throw new Error("Missing the required parameter 'os' when calling getStatsTodayOS");
      }
      var pathParams = {};
      var queryParams = {
        'os': os
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Number';
      return this.apiClient.callApi('/stats/today/os', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getStatsTodayRelType operation.
     * @callback module:api/StatsApi~getStatsTodayRelTypeCallback
     * @param {String} error Error message, if any.
     * @param {Number} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 获取指定发布形式最近一天内报活过的节点总数
     * 获取指定发布形式最近一天内报活过的节点总数
     * @param {String} relType 要统计的 App 发布形式, e.g \"App/Service\",
     * @param {module:api/StatsApi~getStatsTodayRelTypeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Number}
     */
  }, {
    key: "getStatsTodayRelType",
    value: function getStatsTodayRelType(relType, callback) {
      var postBody = null;
      // verify the required parameter 'relType' is set
      if (relType === undefined || relType === null) {
        throw new Error("Missing the required parameter 'relType' when calling getStatsTodayRelType");
      }
      var pathParams = {};
      var queryParams = {
        'RelType': relType
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Number';
      return this.apiClient.callApi('/stats/today/rel-type', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getStatsTodayRunIn operation.
     * @callback module:api/StatsApi~getStatsTodayRunInCallback
     * @param {String} error Error message, if any.
     * @param {Number} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 获取指定运行环境最近一天内报活过的节点总数
     * 获取指定运行环境最近一天内报活过的节点总数
     * @param {String} runIn 要统计的系统, e.g \"BareMetal/Docker/Electron/Systemd/Upstart\",
     * @param {module:api/StatsApi~getStatsTodayRunInCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Number}
     */
  }, {
    key: "getStatsTodayRunIn",
    value: function getStatsTodayRunIn(runIn, callback) {
      var postBody = null;
      // verify the required parameter 'runIn' is set
      if (runIn === undefined || runIn === null) {
        throw new Error("Missing the required parameter 'runIn' when calling getStatsTodayRunIn");
      }
      var pathParams = {};
      var queryParams = {
        'runIn': runIn
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Number';
      return this.apiClient.callApi('/stats/today/run-in', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getStatsTodayTotal operation.
     * @callback module:api/StatsApi~getStatsTodayTotalCallback
     * @param {String} error Error message, if any.
     * @param {Number} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 获取今天报活过的节点数量
     * 获取今天报活过的节点数量, 返回的是最近 24 小时内的统计
     * @param {module:api/StatsApi~getStatsTodayTotalCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Number}
     */
  }, {
    key: "getStatsTodayTotal",
    value: function getStatsTodayTotal(callback) {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Number';
      return this.apiClient.callApi('/stats/today/total', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getStatsTodayVer operation.
     * @callback module:api/StatsApi~getStatsTodayVerCallback
     * @param {String} error Error message, if any.
     * @param {Number} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 获取指定版本最近一天内报活过的节点总数
     * 获取指定版本最近一天内报活过的节点总数
     * @param {String} ver 要统计的版本号, e.g \"0.0.1\",
     * @param {module:api/StatsApi~getStatsTodayVerCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Number}
     */
  }, {
    key: "getStatsTodayVer",
    value: function getStatsTodayVer(ver, callback) {
      var postBody = null;
      // verify the required parameter 'ver' is set
      if (ver === undefined || ver === null) {
        throw new Error("Missing the required parameter 'ver' when calling getStatsTodayVer");
      }
      var pathParams = {};
      var queryParams = {
        'ver': ver
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Number';
      return this.apiClient.callApi('/stats/today/ver', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getStatsTotal operation.
     * @callback module:api/StatsApi~getStatsTotalCallback
     * @param {String} error Error message, if any.
     * @param {Number} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 获取所有报活过的节点数量
     * 获取所有报活过的节点数量
     * @param {module:api/StatsApi~getStatsTotalCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Number}
     */
  }, {
    key: "getStatsTotal",
    value: function getStatsTotal(callback) {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Number';
      return this.apiClient.callApi('/stats/total', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getStatsVer operation.
     * @callback module:api/StatsApi~getStatsVerCallback
     * @param {String} error Error message, if any.
     * @param {Number} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 获取指定版本所有报活过的节点总数
     * 获取指定版本所有报活过的节点总数
     * @param {String} ver 要统计的版本号, e.g \"0.0.1\",
     * @param {module:api/StatsApi~getStatsVerCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Number}
     */
  }, {
    key: "getStatsVer",
    value: function getStatsVer(ver, callback) {
      var postBody = null;
      // verify the required parameter 'ver' is set
      if (ver === undefined || ver === null) {
        throw new Error("Missing the required parameter 'ver' when calling getStatsVer");
      }
      var pathParams = {};
      var queryParams = {
        'ver': ver
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Number';
      return this.apiClient.callApi('/stats/ver', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
  }]);
  return StatsApi;
}();